<!-- 
GroupNewModal.vue
功能：成立一個新的群組視窗
作者：i9400538 陳博承
完成：2021-06-03
-->
<template>
  <div id="group-new-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="text-green m-0 mt-1">成立新的群組</h3>
        </div>
        <div style="padding:20px 40px;">
          <div class="row mt-2 mb-4">
            <div class="col-12">
              <span style="font-size:18px;font-weight:600">
                請新增&nbsp;
                <span class="text-green">所選{{totalCustCount}}位客戶&nbsp;</span>想加入的群組
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group row">
                <div class="col-10 d-flex">
                  <input
                    type="text"
                    maxlength="20"
                    id="group-name"
                    placeholder="請輸入群組名稱"
                    class="form-control"
                    v-model="groupName"
                    alt="ch"
                    @input="checkGroupName"
                    @blur="checkGroupName"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="actions text-right mt-4">
                <a @click="$emit('close')" class="btn btn-default">取消</a>
                <a @click="doNext" :disabled="!groupName" class="btn btn-primary">下一步</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
//service
import { getGroupOfAgnt } from "@/service";
//component
import mxMask from "@/desktop/components/mxMask";

export default {
  name: "CreateOneGroupModal",
  mixins: [commonMixin],
  components: {
    mxMask
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    selectedCust: {
      type: Array
    },
    type: {
      type: String,
      default: ""
    }
  },
  watch: {
    open: function(val) {
      if (val == true) {
        this.groupName = "";
        this.init();
      }
    }
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo"]),
    totalCustCount() {
      return this.selectedCust.length;
    }
  },
  data() {
    return {
      mxMaskOpen: false,
      groupName: "",
      grpsOfAgnt: []
    };
  },
  methods: {
    //檢查群組名稱
    checkGroupName() {
      this.groupName = this.cleanSpecialChar(this.groupName, '@()_');
    },
    //下一步
    doNext() {
      //檢核群組名稱不可為空
      if (!this.groupName) {
        this.$toast.info({ title: "未輸入群組名稱" });
        return;
      }
      //檢核群組名稱不可重複
      for (let i = 0; i < this.grpsOfAgnt.length; i++) {
        if (this.groupName.trim() == this.grpsOfAgnt[i].grp_name.trim()) {
          this.$toast.info({ title: "此群組名稱已經存在" });
          return;
        }
      }
      //通過檢查，往下一步
      this.$emit("createOneGroup", this.groupName);
    },
    init() {
      //取得業務底下所有的群組
      this.mxMaskOpen = true;
      getGroupOfAgnt(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id,
        0
      ).then(result => {
        this.mxMaskOpen = false;
        if (
          result.header &&
          result.header.status === "200" &&
          result.body.groups
        ) {
          this.grpsOfAgnt = result.body.groups.map(item => {
            return {
              grp_id: item.grp_id,
              grp_name: item.grp_name
            };
          });
        } else {
          this.grpsOfAgnt = [];
        }
      });
    }
  }
};
</script>